import { TYPE_AVERAGE, TYPE_SUM } from "@/helpers/constants";
import { formatters } from "@/helpers/formatters";
import { PlanInputDictionary } from "@/types/common";

export const defaultPlanTableHeaders: PlanInputDictionary[] = [
  {
    title: "Business Goal",
    value: "business_goal",
    tableGroup: "dimension",
    lvl: 0,
    persistent: true,
    formatter: formatters.stringFormat,
  },
  {
    title: "Campaign ID",
    value: "campaign_id",
    tableGroup: "dimension",
    lvl: 0,
    persistent: true,
    formatter: formatters.stringFormat,
  },
  {
    title: "Plan",
    value: "plan",
    tableGroup: "dimension",
    lvl: 1,
    persistent: true,
    formatter: formatters.stringFormat,
  },
  {
    title: "Geography",
    value: "geography",
    tableGroup: "dimension",
    lvl: 1,
    formatter: formatters.firstOrAllStates,
  },
  {
    title: "Channel",
    value: "channel",
    tableGroup: "dimension",
    lvl: 2,
    persistent: true,
    formatter: formatters.stringFormat,
  },

  {
    title: "Campaign KPI",
    value: "campaign_kpi",
    tableGroup: "dimension",
    lvl: 2,
    formatter: formatters.stringFormat,
  },
  {
    title: "Start Date",
    value: "start_date",
    tableGroup: "dimension",
    lvl: 2,
    formatter: formatters.formatDate,
  },
  {
    title: "End Date",
    value: "end_date",
    tableGroup: "dimension",
    lvl: 2,
    formatter: formatters.formatDate,
  },
  {
    title: "% of Budget",
    value: "channel_percentage",
    tableGroup: "standard",
    lvl: 2,
    formatter: formatters.compactPercentFormat,
    type: TYPE_SUM,
    editable: false,
  },
  {
    title: "Budget",
    value: "budget",
    tableGroup: "standard",
    lvl: 2,
    persistent: true,
    formatter: formatters.formattedCurrencyNoFraction,
    type: TYPE_SUM,
    editable: true,
  },
  {
    title: "CPM",
    value: "cpm",
    tableGroup: "calculated",
    lvl: 2,
    formatter: formatters.formattedCurrencyTwoDecimals,
    type: TYPE_AVERAGE,
    editable: true,
  },
  {
    title: "Impressions",
    value: "impressions",
    tableGroup: "standard",
    lvl: 2,
    formatter: formatters.plainNumberWithSeparators,
    type: TYPE_SUM,
    editable: true,
  },
];

export const defaultPlanTableTimeHeaders: PlanInputDictionary[] = [
  {
    title: "Business Goal",
    value: "business_goal",
    tableGroup: "dimension",
    lvl: 0,
    persistent: true,
    formatter: formatters.stringFormat,
  },
  {
    title: "Campaign ID",
    value: "campaign_id",
    tableGroup: "dimension",
    lvl: 0,
    persistent: true,
    formatter: formatters.stringFormat,
  },
  {
    title: "Plan",
    value: "plan",
    tableGroup: "dimension",
    lvl: 1,
    persistent: true,
    formatter: formatters.stringFormat,
  },
  {
    title: "Geography",
    value: "geography",
    tableGroup: "dimension",
    lvl: 1,
    formatter: formatters.firstOrAllStates,
  },
  {
    title: "Channel",
    value: "channel",
    tableGroup: "dimension",
    lvl: 2,
    persistent: true,
    formatter: formatters.stringFormat,
  },

  {
    title: "Campaign KPI",
    value: "campaign_kpi",
    tableGroup: "dimension",
    lvl: 2,
    formatter: formatters.stringFormat,
  },
  {
    title: "Budget",
    value: "channel_budget",
    tableGroup: "standard",
    lvl: 2,
    persistent: true,
    formatter: formatters.formattedCurrencyNoFraction,
    type: TYPE_SUM,
    editable: true,
  },
];
